<template>
  <div class="grid-parts__wrap-inner-tools">
    <grid ref="grid" :config="gridConfig" class="no-grid-border">
      <template v-slot:inner-tools>
        <grid-tool-controls
          :controls="gridControls"
          class="inner-tool-controls"
          @command="handleCommand"
        />
      </template>
      <template v-slot:column-control-left="{ row }">
        <li>
          <button
            class="btn btn-size-s"
            @click="sendQuoteToCustomerEmail(row, true)"
          >{{L10n('send-quote-no-stock-to-customer-email')}}</button>
        </li>
      </template>
    </grid>
    <dialog-send-quote-to-customer-email
      ref="dialog-send-quote"
      :rfqID="rfqID"
      :rfq3ID="false"
      @onSuccess="onSuccessSendQuoteToCustomerEmail"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig.json'
import models from '@/components/Grid/models.js'
import { waitValue } from '@/utils/promises'
export default {
  name: 'RFQ1sParts',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'dialog-send-quote-to-customer-email': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SendQuoteToCustomerEmail/Index'),
    'grid-tool-controls': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/GridToolControls')
  },
  props: {
    partID: { required: true },
    editorID: { required: true }
  },
  watch: {
    'partID': {
      immediate: true,
      handler () {
        this.getGrid()
          .then((grid) => {
            if (this.partID) {
              grid.setFilters(`partID == ${this.partID}`)
              grid.loadData()
            }
          })
      }
    }
  },
  data () {
    return {
      rfqID: null,
      gridConfig: gridConfig
    }
  },
  computed: {
    gridControls () {
      return this.$_.merge(models.grid(this.$root).header.controls, {
        isRefresh: true,
        export: {
          json: {
            current: {
              isVisible: false
            },
            all: {
              isVisible: false
            }
          }
        },
        addNew: {
          isVisible: false
        }
      })
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    handleCommand () {
      this.getGrid()
        .then((grid) => {
          grid.handleCommand(...arguments)
        })
    },
    sendQuoteToCustomerEmail (row, noStock) {
      const { rfqID } = row
      this.rfqID = rfqID
      this.$nextTick(() => {
        if (!this.rfqID) return
        this.$refs['dialog-send-quote'].show({ noStock, staticRFQData: row })
      })
    },
    async onSuccessSendQuoteToCustomerEmail () {
      const grid = await this.getGrid()
      grid.refresh()
    }
  }
}
</script>

<style lang="stylus">
</style>
